import "./Window.css"
import React from "react"
import classnames from "classnames"

import UIRect from "./UIRect"

const Window = ({
  children,
  title,
  width,
  height,
  cornerWidth,
  className,
  onClick,
  ...props
}) => {
  className = classnames("WindowContainer", className)

  return (
    <div
      className={className}
      style={{ width, minHeight: height, ...props.style }}
      onClick={onClick}
    >
      {title ? (
        <header className="Window__title-container">
          <div className="Window__title">{title}</div>
          <UIRect
            className="Window__title-bg"
            width={width - 80}
            height={60}
            cornerWidth={30}
          />
        </header>
      ) : null}
      <div className="Window__content" style={{ minHeight: height }}>
        {children}
      </div>
      <UIRect
        className="Window__bg"
        width={width}
        height={height}
        cornerWidth={cornerWidth}
      />
    </div>
  )
}

Window.defaultProps = {
  title: null,
  width: 400,
  height: 400,
  cornerWidth: 40
}

export default Window



// WEBPACK FOOTER //
// ./src/components/Window.js